import { BookOpen, Star, Heart, Sparkles, FileText, CheckCircle, Zap, Target, Users, Shield, Calendar, Clock, Leaf, Apple, Brain, Search, X } from 'lucide-react';
import { usePageContent } from '@/hooks/usePageContent';

const ICON_MAP: Record<string, React.ElementType> = {
  BookOpen,
  Star,
  Heart,
  Sparkles,
  FileText,
  CheckCircle,
  Zap,
  Target,
  Users,
  Shield,
  Calendar,
  Clock,
  Leaf,
  Apple,
  Brain,
};

interface BlogHeroProps {
  searchTerm: string;
  onSearchChange: (v: string) => void;
}

export function BlogHero({ searchTerm, onSearchChange }: BlogHeroProps) {
  const { getText, get } = usePageContent('blog_page');

  const title       = getText('hero', 'title',       'Blog de Nutrição');
  const description = getText('hero', 'description', 'Artigos, dicas e informações sobre nutrição e bem-estar para transformar sua relação com a comida.');
  const pillLabel   = getText('hero', 'pillLabel',   'Conteúdo Gratuito');
  const pillIcon    = getText('hero', 'pillIcon',    'BookOpen');
  const badges      = (get('hero', 'badges')?.content_value?.items as string[]) ?? [];

  const PillIcon = ICON_MAP[pillIcon] ?? BookOpen;

  return (
    <section className="bg-brand-primary py-14 sm:py-20">
      <div className="container mx-auto px-6 text-center">
        <div className="inline-flex items-center gap-2 bg-white/15 text-white/90 text-xs font-semibold px-4 py-1.5 rounded-full mb-5 tracking-wide uppercase">
          <PillIcon className="w-3.5 h-3.5" />
          {pillLabel}
        </div>
        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white font-primary mb-4 leading-tight">
          {title}
        </h1>
        <p className="text-white/75 text-base sm:text-lg max-w-2xl mx-auto font-primary mb-8">
          {description}
        </p>

        {badges.length > 0 && (
          <div className="flex flex-wrap justify-center gap-3 mb-8">
            {badges.map(b => (
              <span key={b} className="flex items-center gap-1.5 bg-white/10 text-white text-sm font-medium px-4 py-1.5 rounded-full">
                {b}
              </span>
            ))}
          </div>
        )}

        {/* Integrated search bar */}
        <div className="max-w-xl mx-auto relative">
          <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-white/50 pointer-events-none" />
          <input
            type="text"
            value={searchTerm}
            onChange={e => onSearchChange(e.target.value)}
            placeholder="Pesquisar artigos..."
            className="w-full pl-11 pr-10 py-3.5 rounded-2xl bg-white/15 border border-white/25 text-white placeholder-white/45 text-sm font-primary focus:outline-none focus:bg-white/20 focus:border-white/50 transition-all"
          />
          {searchTerm && (
            <button
              onClick={() => onSearchChange('')}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-white/50 hover:text-white transition-colors"
            >
              <X className="w-4 h-4" />
            </button>
          )}
        </div>
      </div>
    </section>
  );
}
